import { makeStyles, Grid, Paper, Spacer, StyledSkeleton } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    borderRadius: 2,
    boxShadow: '0px 5px 15px 0px rgba(0, 0, 0, 0.25)',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: 954,
    [theme.breakpoints.down('md')]: {
      width: 718
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  content: {
    padding: '40px 30px',
    [theme.breakpoints.down('md')]: {
      padding: '20px 20px'
    },
    '@media print': {
      padding: '0'
    }
  }
}))

export default function QuoteShim() {
  const classes = useStyles({})

  return (
    <Paper className={classes.root}>
      <div className={classes.content}>
        <Header />
        <Spacer />
        <AreaTable />
      </div>
    </Paper>
  )
}

const Header = () => {
  return (
    <Grid container spacing={4}>
      <Grid item xs={12} md={4}>
        <StyledSkeleton height={'100px'} />
      </Grid>
      <Grid item xs={12} md={4}>
        <StyledSkeleton height={'100px'} />
      </Grid>
      <Grid item xs={12} md={4}>
        <StyledSkeleton height={'100px'} />
      </Grid>
      <Grid item xs={12} md={4}>
        <StyledSkeleton height={'100px'} />
      </Grid>
      <Grid item xs={6} md={4}>
        <StyledSkeleton height={'100px'} />
      </Grid>
      <Grid item xs={6} md={4}>
        <StyledSkeleton height={'100px'} />
      </Grid>
    </Grid>
  )
}

const AreaTable = () => {
  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <StyledSkeleton height={'300px'} />
      </Grid>
      <Grid item xs={12} md={6} />
      <Grid item xs={12} md={6}>
        <StyledSkeleton height={'200px'} />
      </Grid>
    </Grid>
  )
}
